import React from 'react';
import { Card, Row, Col, Tag, Timeline, Divider } from 'antd';

const SimpleAlluvialDemo = () => {
    // 模拟Alluvial图的数据结构
    const timeSteps = [
        {
            title: 'T1-初始状态',
            time: '08:00',
            entities: [
                { name: 'CT107', type: 'flight', status: '待处理' },
                { name: 'CT108', type: 'flight', status: '待处理' },
                { name: 'CT109', type: 'flight', status: '待处理' }
            ]
        },
        {
            title: 'T2-事务创建',
            time: '09:00',
            entities: [
                { name: '许可申请', type: 'transaction', status: '已创建' },
                { name: '燃油申请', type: 'transaction', status: '已创建' },
                { name: '配餐订单', type: 'transaction', status: '已创建' },
                { name: '航班变更', type: 'transaction', status: '已创建' }
            ]
        },
        {
            title: 'T3-批次汇聚',
            time: '10:00',
            entities: [
                { name: 'BATCH-001', type: 'batch', status: '汇聚中', count: 3 },
                { name: 'BATCH-002', type: 'batch', status: '汇聚中', count: 1 },
                { name: 'BATCH-003', type: 'batch', status: '汇聚中', count: 1 },
                { name: 'BATCH-004', type: 'batch', status: '汇聚中', count: 1 }
            ]
        },
        {
            title: 'T4-供应商处理',
            time: '11:00',
            entities: [
                { name: 'UAS处理', type: 'supplier', status: '处理中' },
                { name: 'AEG处理', type: 'supplier', status: '处理中' },
                { name: '航食处理', type: 'supplier', status: '处理中' },
                { name: '机场处理', type: 'supplier', status: '处理中' }
            ]
        },
        {
            title: 'T5-最终状态',
            time: '16:00',
            entities: [
                { name: '许可已批准', type: 'result', status: '完成' },
                { name: '燃油已确认', type: 'result', status: '完成' },
                { name: '配餐已确认', type: 'result', status: '完成' },
                { name: '变更已生效', type: 'result', status: '完成' }
            ]
        }
    ];

    const getTypeColor = (type) => {
        const colors = {
            flight: 'blue',
            transaction: 'orange',
            batch: 'green',
            supplier: 'purple',
            result: 'red'
        };
        return colors[type] || 'default';
    };

    const getTypeIcon = (type) => {
        const icons = {
            flight: '✈️',
            transaction: '📋',
            batch: '📦',
            supplier: '🏢',
            result: '✅'
        };
        return icons[type] || '📊';
    };

    return (
        <div style={{ padding: '20px' }}>
            <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                <h3>🌊 Alluvial图演示 - 多时间点状态流</h3>
                <p style={{ color: '#666', fontSize: '14px' }}>
                    展示航班事务在不同时间点的状态变化和流向关系
                </p>
            </div>

            <Row gutter={[16, 16]}>
                {timeSteps.map((step, index) => (
                    <Col span={24} key={index}>
                        <Card 
                            size="small"
                            title={
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <span style={{ 
                                        background: '#1890ff', 
                                        color: 'white', 
                                        padding: '2px 8px', 
                                        borderRadius: '4px',
                                        fontSize: '12px'
                                    }}>
                                        {step.time}
                                    </span>
                                    <span>{step.title}</span>
                                </div>
                            }
                            style={{ 
                                border: '2px solid #f0f0f0',
                                borderRadius: '8px',
                                background: index % 2 === 0 ? '#fafafa' : '#ffffff'
                            }}
                        >
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                {step.entities.map((entity, entityIndex) => (
                                    <Tag 
                                        key={entityIndex}
                                        color={getTypeColor(entity.type)}
                                        style={{ 
                                            margin: '2px',
                                            padding: '4px 8px',
                                            fontSize: '12px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        <span>{getTypeIcon(entity.type)}</span>
                                        <span>{entity.name}</span>
                                        {entity.count && (
                                            <span style={{ 
                                                background: 'rgba(255,255,255,0.3)', 
                                                padding: '1px 4px', 
                                                borderRadius: '2px',
                                                fontSize: '10px'
                                            }}>
                                                {entity.count}
                                            </span>
                                        )}
                                    </Tag>
                                ))}
                            </div>
                            
                            {index < timeSteps.length - 1 && (
                                <div style={{ 
                                    textAlign: 'center', 
                                    marginTop: '12px',
                                    color: '#999',
                                    fontSize: '12px'
                                }}>
                                    ⬇️ 流向下一阶段
                                </div>
                            )}
                        </Card>
                    </Col>
                ))}
            </Row>

            <Divider />

            <div style={{ marginTop: '20px' }}>
                <h4>📈 流向关系说明</h4>
                <Timeline
                    items={[
                        {
                            children: (
                                <div>
                                    <strong>航班初始化</strong>
                                    <br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>
                                        3个航班进入系统，等待事务处理
                                    </span>
                                </div>
                            ),
                        },
                        {
                            children: (
                                <div>
                                    <strong>事务创建与分类</strong>
                                    <br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>
                                        根据航班需求创建不同类型的事务：许可、燃油、配餐、变更
                                    </span>
                                </div>
                            ),
                        },
                        {
                            children: (
                                <div>
                                    <strong>批次汇聚处理</strong>
                                    <br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>
                                        相同类型的事务汇聚成批次，提高处理效率
                                    </span>
                                </div>
                            ),
                        },
                        {
                            children: (
                                <div>
                                    <strong>供应商并行处理</strong>
                                    <br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>
                                        不同供应商同时处理各自负责的批次
                                    </span>
                                </div>
                            ),
                        },
                        {
                            children: (
                                <div>
                                    <strong>最终状态确认</strong>
                                    <br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>
                                        所有事务完成处理，航班获得最终确认
                                    </span>
                                </div>
                            ),
                        },
                    ]}
                />
            </div>

            <div style={{ 
                marginTop: '20px', 
                padding: '16px', 
                background: '#f6ffed', 
                border: '1px solid #b7eb8f',
                borderRadius: '6px'
            }}>
                <h4 style={{ color: '#52c41a', margin: '0 0 8px 0' }}>💡 Alluvial图特点</h4>
                <ul style={{ margin: 0, paddingLeft: '20px', color: '#666' }}>
                    <li>展示多个时间点的状态快照</li>
                    <li>清晰显示实体在不同阶段的流向</li>
                    <li>支持多对多的复杂关系可视化</li>
                    <li>适合分析批次处理和状态变迁</li>
                </ul>
            </div>
        </div>
    );
};

export default SimpleAlluvialDemo;
